// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2nbPr","head":"Table_head__gH5k-","col":"Table_col__X8KgP"};